// extracted by mini-css-extract-plugin
export default {"primary":"#7366ff","secondary":"#f73164","success":"#51bb25","info":"#a927f9","warning":"#f8d62b","danger":"#dc3545","light":"#efefef","dark":"#898989"};